import { getApiBaseUrl } from '../../utils/appConfig';
import { getAdminAuthToken } from '../jscontrol/apiClient';

export async function uploadImageFiles(uploadPath, files) {
  const fileList = Array.from(files || []).filter((f) => f && f.size > 0);
  if (fileList.length === 0) {
    throw new Error('Please select at least one image.');
  }

  const baseUrl = getApiBaseUrl();
  const token = getAdminAuthToken();
  const formData = new FormData();
  fileList.forEach((file) => formData.append('files', file));

  const endpoint = fileList.length === 1 ? `${uploadPath}/Upload` : `${uploadPath}/UploadMultiple`;
  if (fileList.length === 1) {
    const single = new FormData();
    single.append('file', fileList[0]);
    const res = await fetch(`${baseUrl}${uploadPath}/Upload`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: single,
    });
    const json = await res.json().catch(() => null);
    if (!res.ok || json?.success === false) {
      throw new Error(json?.message || json?.Message || `Upload failed (${res.status})`);
    }
    const url = json?.imageUrl || json?.ImageUrl || json?.data?.imageUrl || json?.data?.ImageUrl;
    if (!url) throw new Error('Upload succeeded but no image URL was returned.');
    return [url];
  }

  const res = await fetch(`${baseUrl}${endpoint}`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });
  const json = await res.json().catch(() => null);
  if (!res.ok || json?.success === false) {
    throw new Error(json?.message || json?.Message || `Upload failed (${res.status})`);
  }
  const urls = json?.imageUrls || json?.ImageUrls || json?.data?.imageUrls || json?.data?.ImageUrls;
  if (!Array.isArray(urls) || urls.length === 0) {
    throw new Error('Upload succeeded but no image URLs were returned.');
  }
  return urls;
}
